jQuery(document).ready(function ($) {
  console.log("jquery document ready");
});
